import { render, staticRenderFns } from "./PlmSampleList.vue?vue&type=template&id=1a8e7646"
import script from "./PlmSampleList.vue?vue&type=script&lang=js"
export * from "./PlmSampleList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports